import { render } from "./PaymentInput.vue?vue&type=template&id=9b387482&scoped=true"
import script from "./PaymentInput.vue?vue&type=script&lang=js"
export * from "./PaymentInput.vue?vue&type=script&lang=js"

import "./PaymentInput.vue?vue&type=style&index=0&id=9b387482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b387482"]])

export default __exports__